// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"536d5482","612":"819d212b"}[chunkId] + ".chunk.js";
};